export default __webpack_public_path__ + "static/media/close-btn.92ba8f69.svg";